<template>
  <div id="app" v-scroll-spy>
    <custom-header :menu="menu"></custom-header>
    <welcome v-if="isFront()"></welcome>
    <hero-section v-if="page.fieldHeroSection" :content="page.fieldHeroSection"></hero-section>
    <anchor-navigation v-if="hasAnchors(anchors)" :anchors="anchors"></anchor-navigation>
    <content-section :content="page.fieldInhalte"></content-section>
    <custom-footer :content="footer"></custom-footer>
  </div>
</template>

<script>
  import CustomHeader from './components/System/Header.vue';
  import CustomFooter from './components/System/Footer.vue';

  import menuQuery from './apollo/queries/MenuQuery.gql';
  import anchorQuery from './apollo/queries/AnchorQuery.gql';
  import pageQuery from './apollo/queries/NodePage.gql';
  import footerQuery from './apollo/queries/FooterQuery.gql';

  import debounce from 'lodash/debounce'
  import {scroller} from 'vue-scrollto/src/scrollTo'

  export default {
    name: 'App',
    components: {
      'custom-header': CustomHeader,
      'anchor-navigation': () => import ('./components/System/AnchorNavigation'),
      'welcome': () => import('./components/Sections/WelcomeSection'),
      'hero-section': () => import('./components/Sections/HeroSection'),
      'content-section': () => import('./components/Sections/ContentSection'),
      'custom-footer': CustomFooter,
    },
    data() {
      return {
        menu: {},
        anchors: {},
        page: {},
        footer: {},
      }
    },
    apollo: {
      menu: {
        prefetch: true,
        query: menuQuery,
        options: {
          errorPolicy: 'all',
        },
        update(data) {
          return data.menuByName.links;
        }
      },
      anchors: {
        prefetch: ({route}) => ({value: window.location.pathname}),
        query: anchorQuery,
        options: {
          errorPolicy: 'all',
        },
        variables() {
          return {value: window.location.pathname};
        },
        update(data) {
          return data.nodeQuery.entities[0];
        }
      },
      page: {
        prefetch: ({route}) => ({value: window.location.pathname}),
        query: pageQuery,
        options: {
          errorPolicy: 'all',
        },
        variables() {
          return {value: window.location.pathname};
        },
        update(data) {
          return data.nodeQuery.entities[0];
        }
      },
      footer: {
        prefetch: true,
        query: footerQuery,
        options: {
          errorPolicy: 'all',
        },
        update(data) {
          return data.nodeQuery.entities[0];
        }
      },
    },
    methods: {
      isFront: function() {
        if(window.location.pathname == "/") return true
        else return false;
      },
      hasAnchors: function(anchors) {
        if(window.location.pathname == "/") return false
        if(anchors.fieldInhalte != null) {
          if(anchors.fieldInhalte.length > 1) return true
          else return false
        }
        else return false
      },
      scrollTo: function(hash) {
        const loadScrollTo = scroller()
        loadScrollTo(hash)
      }
    },
    updated: debounce(function () {
      this.$nextTick(() => {
        window.addEventListener('DOMContentLoaded', this.scrollTo(location.hash))
      })
    }, 250)
  }
</script>

<style lang="sass">
  @import "./assets/sass/main.sass"

  html, body
    scroll-behavior: smooth

</style>
